module.exports = __webpack_public_path__ + "static/footer1-3be101d599de20f5dfd26c32307a2811.png";